import axios from "axios";

import Config from "src/config";

const v1_actionWboUploadMidiaTemplate = (clienteId, formData) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/canais/wbo/templates/upload-midia`,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

export default v1_actionWboUploadMidiaTemplate;
